import { useGetReferenceQuery } from '@redux/references/slice';
import { compact } from 'lodash';
import React from 'react';

const AddressLabel = ({ locationId }) => {
  const { data } = useGetReferenceQuery(
    {
      model: 'locations',
      filters: {
        filters: [
          {
            condition: 'and',
            key: 'id',
            operator: 'is',
            value: locationId,
          },
        ],
      },
    },
    {
      skip: !locationId,
    },
  );

  const currLocation = data?.find((item) => item?.id === locationId);

  return (
    <div className="text-[--text-secondary] text-sm">
      {compact([
        currLocation?.addressLine,
        currLocation?.ward,
        currLocation?.district,
        currLocation?.province,
      ]).join(', ')}
    </div>
  );
};

export default AddressLabel;
